import Image16 from '@carbon/icons-react/es/image/16';
import { Tooltip } from 'antd';
import React, { ChangeEvent, FC, useRef } from 'react';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';

interface InsertImageProps {
  enabled: boolean;
  onSelect: (files: FileList) => void;
}

export const InsertImage: FC<InsertImageProps> = ({
  enabled,
  onSelect,
}: InsertImageProps) => {
  const ref = useRef<HTMLInputElement | null>(null);
  const insertImageCaption = useTranslation('rte.plugins.image.insert_caption');
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    event.preventDefault();
    const target = event.target as HTMLInputElement;

    if (target.files == null) {
      return;
    }
    onSelect(target.files);
  };

  return (
    <>
      <input
        id="myInput"
        type="file"
        ref={ref}
        className="hide"
        onChange={onChange}
        multiple
        accept="image/*"
        data-cy="rte.upload.image.input"
      />
      <Tooltip title={insertImageCaption}>
        <Button
          type="text"
          disabled={!enabled}
          aria-label={insertImageCaption}
          icon={<Image16 className="carbon-icon" />}
          onClick={() => ref.current!.click()}
          data-cy="rte.upload.image"
        />
      </Tooltip>
    </>
  );
};
